document.addEventListener("DOMContentLoaded", () => {
    const jumpToSelect = document.querySelector("#jump-to");
    if( !jumpToSelect ) return;

    jumpToSelect.addEventListener("change", (event) => {
        const selector = event.target.value;
        const target = document.querySelector(selector);
        if( !target ) return;

        // Get offset based on breakpoint
        const breakpoint = window.universityPressThemeSettings?.fixed_header_breakpoint ?? 960;
        const offset = window.innerWidth < breakpoint
            ? window.universityPressThemeSettings?.az_dropdown_mobile_offset ?? 150
            : window.universityPressThemeSettings?.az_dropdown_desktop_offset ?? 100;

        const topPosition = target.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
            top: topPosition,
            behavior: "smooth"
        });
    });
});
